import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { RepeatOrderService } from '@app/shared/services/repeat-order.service';
import { OrderDataService } from '@app/shared/services/order-data.service';
import { LabelPrintService } from '@app/shared/services/label-print.service';
import { forkJoin, of } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-label-print',
  templateUrl: './label-print.component.html',
  styleUrls: ['./label-print.component.css']
})
export class LabelPrintComponent implements OnInit {

  labelPrintForm: FormGroup;
  tickets = []; // Array to hold all ticket numbers
  rowCount: number = 1; // Default row count set to 1

  constructor(
    private formBuilder: FormBuilder,private Router:Router,
    private repeatOrderService: RepeatOrderService,
    private orderDataService: OrderDataService,private LabelPrintService:LabelPrintService, private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    // Fetch both repeat orders and unsaved orders
    forkJoin({
      repeatOrders: this.repeatOrderService.getAllRepeatOrder(),
      unsavedOrders: this.orderDataService.getAllUnsavedOrders()
    }).subscribe(response => {
      // Ensure the response objects are arrays, otherwise set them as empty arrays
      const repeatOrders = Array.isArray(response.repeatOrders) ? response.repeatOrders : [];
      const unsavedOrders = Array.isArray(response.unsavedOrders) ? response.unsavedOrders : [];

      // Combine both orders into a single array (could also add custom properties to differentiate)
      this.tickets = [...repeatOrders, ...unsavedOrders];
       // Sort tickets in ascending order based on ticketNo
    this.tickets.sort((a, b) => {
      const ticketNoA = a.ticketNo ? a.ticketNo : '';
      const ticketNoB = b.ticketNo ? b.ticketNo : '';
      return ticketNoA.localeCompare(ticketNoB); // Ensure correct sorting by ticketNo
    });

      this.cdr.detectChanges(); // This forces the UI to update after data is populated

      console.log("ticket",this.tickets);
    });
    
      // Initialize the form with a default single row
      this.labelPrintForm = this.formBuilder.group({
        ticketNo: ['', Validators.required],
        jobName: ['', Validators.required],
        width: ['', Validators.required],
        date: ['', Validators.required],
        batch: ['', Validators.required],
        enteredRollNo: [''],  // Add enteredRollNo to form group
        row: this.formBuilder.array([this.createRow()]) // Default 1 row
      });
        // Initially apply enteredRollNo to the first row if provided
    const enteredRollNo = this.labelPrintForm.get('enteredRollNo')?.value;
    if (enteredRollNo) {
      const rowArray = this.labelPrintForm.get('row') as FormArray;
      const firstRow = rowArray.at(0); // Get the first row
      firstRow.patchValue({
        rollNo: enteredRollNo  // Set the rollNo of the first row to enteredRollNo
      });
    }
  }
  // Method to create a new row (FormGroup)
  createRow(): FormGroup {
    return this.formBuilder.group({
      // jobName: ['', Validators.required],
      // width: ['', Validators.required],
     
      // date: ['', Validators.required],
      // batch: ['', Validators.required],
      rollNo: ['', Validators.required],
      netwet: ['', Validators.required],
    });
  }


onRowNumberChange(event: any) {
  const rowNumber = event.target.value;  // Get the number of rows to create
  const enteredRollNo = this.labelPrintForm.get('enteredRollNo')?.value;  // Get enteredRollNo from form control

  if (rowNumber && rowNumber > 0) {
    this.rowCount = rowNumber;
    const rowArray = this.labelPrintForm.get('row') as FormArray;

    // Check if there is any existing row and get the values from the first row (if available)
    const firstRowValues = rowArray.at(0)?.value;
    // const jobName = firstRowValues?.jobName || '';
    // const width = firstRowValues?.width || '';
    const netwet = firstRowValues?.netwet || '';
    // const batch = firstRowValues?.batch || '';

    // Remove existing rows before adding new ones
    while (rowArray.length) {
      rowArray.removeAt(0);
    }

    // Create new rows and patch values
    for (let i = 0; i < rowNumber; i++) {
      const newRow = this.createRow();

      // Patch the values to each row
      newRow.patchValue({
        // jobName: jobName,          // Use the jobName from the first row (or use a default)
        // width: width,              // Use the width from the first row (or use a default)
        netwet: netwet,            // Use the netwet from the first row (or use a default)
        // batch: batch,              // Use the batch from the first row (or use a default)
        rollNo: enteredRollNo ? `${enteredRollNo}-${i + 1}` : '',  // Dynamic rollNo with index
      });

      // Push the new row into the FormArray
      rowArray.push(newRow);
    }

    // Trigger change detection to update the view
    this.cdr.detectChanges();
  } else {
    console.error('Invalid row number');
  }
}

onTicketSelect(event: any): void {
  const selectedTicketNo = event.target.value;
  if (selectedTicketNo) {
    const selectedTicket = this.tickets.find(ticket => ticket.ticketno === selectedTicketNo);
    if (selectedTicket) {
      const width = selectedTicket.coilWidth || 'Default Width';
      const jobName = selectedTicket.jobName || 'Default Job Name';
      this.labelPrintForm.patchValue({
      //  ticketNo: selectedTicket.ticketno,
       jobName: jobName,
        width: width,
       // date: selectedTicket.date,
        batch: selectedTicketNo
      });
      // const jobName = selectedTicket.jobName || 'Default Job Name';
      // const width = selectedTicket.coilWidth || 'Default Width'; // Or another field for width
      // const rowArray = this.labelPrintForm.get('row') as FormArray;
      
      // Patch values for all rows based on the selected ticket
      // rowArray.controls.forEach((rowGroup: FormGroup) => {
      //   rowGroup.patchValue({
      //     jobName: jobName,
      //     width: width, // Set the width based on the selected ticket
      //   });
      // });
    }
  }
}


labelPrint() {
  console.log(this.labelPrintForm.value);
  const formData = this.labelPrintForm.value;

  // Prepare data object to save with all rows
  const dataToSave = {
    ticketNo: formData.ticketNo,
    jobName: formData.jobName,
    width: formData.width,
    date: formData.date,
    batch: formData.batch,
    row: formData.row.map((row: any) => ({
     // jobName: row.jobName,
     // width: row.width,
      rollNo: row.rollNo,
     // date: row.date,
      //batch: row.batch,
      netwet: row.netwet,
    })),
  };

  // Call the service to save data
  this.LabelPrintService.addLabelPrint(dataToSave).subscribe(
    (response) => {
      console.log('Data saved successfully:', response);
      // Optionally reset form or perform other actions after successful save LabelPrintList
      this.Router.navigateByUrl('/LabelPrintList');  // This will redirect to the correct URL

    },
    (error) => {
      console.error('Error saving data:', error);
    }
  );
}

}



// onRowNumberChange(event: any) {
//   const rowNumber = event.target.value;
//   const enteredRollNo = this.enteredRollNo;  // Get the entered Roll Number from the model

//   if (rowNumber && rowNumber > 0) {
//     this.rowCount = rowNumber;
//     const rowArray = this.labelPrintForm.get('row') as FormArray;

//     // Capture the values from the first row (you can modify this to select from any row if needed)
//     const firstRowValues = rowArray.at(0)?.value;
//     const jobName = firstRowValues?.jobName || '';
//     const width = firstRowValues?.width || '';
//     const netwet = firstRowValues?.netwet || '';
//     const batch = firstRowValues?.batch || '';
//     const initialRollNo = enteredRollNo ? enteredRollNo : '';  // Default value for rollNo if empty

//     // Remove existing rows before adding new ones
//     while (rowArray.length) {
//       rowArray.removeAt(0);
//     }

//     // Create new rows with updated rollNo and other values
//     for (let i = 0; i < rowNumber; i++) {
//       const newRow = this.createRow();
//       newRow.patchValue({
//         jobName: jobName,           // Preserve jobName from the first row
//         width: width,               // Preserve width from the first row
//         netwet: netwet,             // Preserve netwet from the first row
//         batch: batch,               // Preserve batch from the first row
//         rollNo: enteredRollNo ? `${enteredRollNo}-${i + 1}` : '',  // Dynamic rollNo based on index
//       });
//       rowArray.push(newRow);
//     }

//     // Trigger change detection to update the view
//     this.cdr.detectChanges();
//   } else {
//     console.error('Invalid row number');
//   }
// }

// Handle ticket selection change and populate jobName based on ticket selection

 // Handle row number input change
//  onRowNumberChange(event: any) {
//   const rowNumber = event.target.value;
//   const enteredRollNo = this.enteredRollNo; // Capture the entered Roll Number

//   if (rowNumber && rowNumber > 0) {
//     this.rowCount = rowNumber;
//     const rowArray = this.labelPrintForm.get('row') as FormArray;
//     const firstRowValues = rowArray.at(0).value;
//     const jobName = firstRowValues.jobName;
//     let initialRollNo = firstRowValues.rollNo ? firstRowValues.rollNo : '';
//     let baseRollNo = initialRollNo.split('-')[0];

//     while (rowArray.length) {
//       rowArray.removeAt(0);
//     }

//     for (let i = 0; i < rowNumber; i++) {
//       const newRow = this.createRow();
//       newRow.patchValue({
//         width: firstRowValues.width,
//         netwet: firstRowValues.netwet,
//         batch: firstRowValues.batch,
//         rollNo: baseRollNo + '-' + (i + 1),
//         jobName: jobName
//       });
//       rowArray.push(newRow);
//     }
//     this.cdr.detectChanges();  // Trigger change detection to update the view
//   } else {
//     console.error('Invalid row number');
//   }
// }